// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorCard_error__29WLk"};